import * as React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
// import { SideText } from './SideText';
import Switch from '@material-ui/core/Switch';

import { IProps } from './interfaces';

import styles from './Checkbox.module.styl';

class Checkbox extends React.Component<IProps> {
  public render() {
    const {
      input,
      meta,
      title,
      disabled,
      sideComponent: SideComponent,
      hasSideComponent,
    } = this.props;

    const control = (
      <Switch
        checked={Boolean(input.value)}
        disabled={disabled}
        onChange={this.handleChange}
        value="checkedB"
        color="primary"
      />
    );

    return (
      <div className={styles.root}>
        <FormControlLabel control={control} label={title} />
        {meta.touched && meta.error && <span>{meta.error}</span>}
        {hasSideComponent && <SideComponent {...this.props} />}
      </div>
    );
  }

  private readonly handleChange = (event: any) => {
    const {
      input: { onChange },
    } = this.props;

    onChange(event.target.checked);
  };
}

export default Checkbox;
